import config from "../../app.config.js";
import apiSoap from "../../api/soapauth";
import authService from "../../services/authService.js";
import AppSettings from "../../services/appSettingsManager";

const availableModulesTableName = "TLoginModules";
const availableFeaturesTableName = "TLoginFeatures";
const clientDefaultsTable = "TClient_Defaults";

const userInfoKeys = [
  "accountId",
  "clientId",
  "userName",
  "userPassHidden",
  "fullName",
  "firstName",
  "middleInitial",
  "familyName",
  "emailAddress",
  "passwordCreatedDate",
  "passwordChangeBoolean",
  "activeDate",
  "inactiveDate",
  "passwordSuspendedBoolean",
  "vernacular",
  "dateFormat",
  "numberFormat",
  "dateSeparator",
  "entityRestricted",
  "editDate",
  "editUserId",
];

export default {
  namespaced: true,

  state: {
    // curUser: {},
  },

  getters: {
    currentUser(state) {
      return authService.getCurrentUser();
    },
    canApprovePayments(state) {},
  },

  mutations: {
    SET_CURRENT_USER_FROM_FULL_RESPONSE(state, fullResponse) {
      console.log("SETTING CURRENT USER:", fullResponse);

      //FYI, THE ARRAY IS NAMED 'item' RATHER THAN 'items' DUE TO WHAT'S PASSED FROM THE SERVER.  IT WAS NOT A PERSONAL CHOICE
      let relevantInfoSplit = fullResponse.soapResultSection.item[1].split(/[\r\n]+/);
      //relevantInfoSplit[0] -> Table and rowcount (only useful if respecting MODULES)
      //relevantInfoSplit[1] -> TAB-delineated (we care about this)

      let userInfo = relevantInfoSplit[1].split(/\t/); //ONLY SPLIT ON SINGLE TAB BECAUSE IT MEANS THERE'S A BLANK VALUE BETWEEN

      let tmpUser = {};
      for (let idx in userInfoKeys) {
        tmpUser[userInfoKeys[idx]] = userInfo[idx];
      }

      authService.setCurrentUser(tmpUser);
      console.log("UPDATED USER:", tmpUser);
    },
    RESET_USER_PERMISSIONS(state) {
      authService.resetUserPermissions();
    },
    SET_USER_PERMISSION(state, { key, val }) {
      authService.setUserPermission(key, val);
    },
    SET_MASS_PERMISSIONS(state, permissions) {
      //DETAIL: ASSUMES key/value OBJECT OF PERMISSIONS
      authService.setMassUserPermissions(permissions);
    },
  },

  actions: {
    async autoLogin({ dispatch, commit, getters, rootGetters }, { username, userpass }) {
      //FIXME: DO WE REALLY WANT AUTOLOGIN OR JUST USE WHAT WE'VE GOT SOMEHOW???!?!??
      //FIXME: THE ISSUE WE NEED TO ADDRESS IS MAKING SURE ANY "NEW ACCESS" RESPECTS UPDATED PERMISSIONS
      return dispatch("login", { username: username, userpass: userpass });
    },
    async login({ dispatch, commit, getters, rootGetters }, { username, userpass }) {
      //NOTE: USERNAME AND PASSWORD GET PASSED IN BUT THE CONFIGURATION SETTINGS SHOULD BE SAVED LOCALLY
      //GRAB STORED SETTINGS (OR USE CONFIG SETTINGS IF NOTHING SET [SHOULD BE FOR DEBUG ONLY])

      let credentialsPayload = Object.assign(
        { username, userpass },
        config,
        AppSettings.getConnectionSettings()
      );

      console.log("ACTIONS/LOGIN");
      console.log(credentialsPayload);
      return new Promise((resolve, reject) => {
        //IF WE DON'T HAVE ALL CONNECTION INFORMATION WE SIMPLY SHORT-CIRCUIT THE PROCESS
        if (!AppSettings.hasCompleteConnectionSettings()) {
          console.log("INCOMPLETE SETTINGS");
          reject({ errorMessage: "Incomplete Connection Settings!" });
          return false;
        }
        apiSoap
          .login(credentialsPayload)
          .then((resp) => {
            if (resp.soapResultSection && resp.soapResultSection.item) {
              // console.log("SOAP RESULT", resp.soapResultSection);
              switch (resp.soapResultSection.item[0]) {
                case "[SUCCESS]":
                  commit("SET_CURRENT_USER_FROM_FULL_RESPONSE", resp);
                  resp.loginSuccess = true;
                  // console.log("CREDENTIALPAYLOAD", credentialsPayload);
                  authService.setAuthTokenFromSuccessfulCredentials(
                    credentialsPayload.username,
                    credentialsPayload.userpass,
                    credentialsPayload.client_id
                  );
                  //TODO: WRITE PERMISSIONS TO DATABASE
                  dispatch("storeModulesAndFeatures", {
                    loginResponseString: resp.soapResultSection.item[1],
                  });
                  break;
                case "[FAILED USER]":
                case "[FAILED PW]":
                  console.log("LOGIN FAILED: " + resp.soapResultSection.item[1]);
                  dispatch("logout");
                  reject({ errorMessage: "LOGIN FAILED: " + resp.soapResultSection.item[1] });
                  break;
                case "[CHANGE PW]":
                  dispatch("logout");
                  reject({
                    errorMessage:
                      "Login was successful, however, you are required to change your password by means of a proper client!",
                  });
                  break;
                case "[INVALID PW]":
                  dispatch("logout");
                  reject({ errorMessage: "LOGIN FAILED: Invalid password for this user!" });
                  break;
                case "[SUSPENDED]":
                  dispatch("logout");
                  reject({
                    errorMessage:
                      "LOGIN FAILED: ACCOUNT SUSPENDED!!! PLEASE CONTACT SYSTEM ADMINISTRATOR!",
                  });
                  break;
                case "[LOGIN FAILED]":
                  console.log(resp.soapResultSection.item[1]);
                  authService.destroyToken();
                  break;
                default:
                  console.log(
                    "Server responded with unknown error.  Please review configuration and credentials."
                  );
              }
            } else {
              console.log(
                "An unknown error has occurred.  Please check your configuration settings and/or contact Orbit support."
              );
            }
            resolve(resp);
          })
          .catch((err) => {
            console.log("LOGIN ERROR:");
            console.log(err);

            authService.destroyToken();
            reject(err);
          });
      });
    },
    logout(context) {
      context.state.user = {};
      authService.destroyToken();
    },
    storeModulesAndFeatures({ dispatch, rootGetters }, { loginResponseString }) {
      //ASSUMES THERE IS A dbService IN EXISTENCE
      const dbService = rootGetters["localdb/dbService"];

      //MAKE SURE WE HAVE LOCAL DB SERVICE?
      if (!dbService) {
        return false;
      }

      let loginResponseArray = loginResponseString.split(/\n/);

      let tPrincipalInfo = loginResponseArray.shift(); //IT'S ALWAYS 1 ROW
      let loginUserInfo = loginResponseArray.shift();

      //INSERT MODULE ROW INFORMATION TO 'availableModulesTableName'
      let availableModulesRowCount = loginResponseArray.shift().split(/\t/)[1]; //LOOKS SOMETHING LIKE "TAvailable_modules	9"

      dbService.executeQuery(`DELETE FROM ${availableModulesTableName}`); //DELETE FROM DB BEFORE INSERTS

      for (let i = 0; i < availableModulesRowCount; i++) {
        const row = loginResponseArray.shift();
        let data = row
          .split(/\t/)
          .map((item) => {
            return parseInt(item) ? item : `'${item.replace("'", "''")}'`;
          })
          .join(",");

        dbService.executeQuery(`INSERT INTO ${availableModulesTableName} VALUES(${data})`);
      }

      //INSERT MODULE FEATURES INFORMATION TO
      let availableFeaturesRowCount = loginResponseArray.shift().split(/\t/)[1]; //LOOKS SOMETHING LIKE "TFeatures	9"

      dbService.executeQuery(`DELETE FROM ${availableFeaturesTableName}`);

      for (let j = 0; j < availableFeaturesRowCount; j++) {
        const row = loginResponseArray.shift();
        let data = row
          .split(/\t/)
          .map((item) => {
            return parseInt(item) ? item : `'${item.replace("'", "''")}'`;
          })
          .join(",");

        dbService.executeQuery(`INSERT INTO ${availableFeaturesTableName} VALUES(${data})`);
      }
      dispatch("refreshUserPermissionsFromModulesAndFeatures");
    },
    refreshUserPermissionsFromModulesAndFeatures({ state, commit, rootGetters }) {
      //ASSUMES THERE IS A dbService IN EXISTENCE
      const dbService = rootGetters["localdb/dbService"];

      //GRAB WHAT WE JUST STORED TO PASS TO NEXT METHOD
      //DETAIL: ASSUMES 'storeModuleAndFeatures' HAS EXECUTED
      let permissionsQuery = `SELECT
      (SELECT rid FROM ${availableFeaturesTableName} where moduleName = 'CASH' AND feature = 'APPROVE_EFT_RELEASE2') IS NOT NULL as userMayApproveEFT,
      (SELECT rid FROM ${availableFeaturesTableName} where moduleName = 'CASH' AND feature = 'RESET_EFT_STATUS') IS NOT NULL as userMayResetEFT,
      (SELECT rid FROM ${availableFeaturesTableName} where moduleName = 'CASH' AND feature IN ('APPROVE_EFT_RELEASE1','APPROVE_EFT_RELEASE2')) IS NOT NULL as userMayReleaseEFT,
      (SELECT defaultValue FROM ${clientDefaultsTable} where name = 'WTR_MAY_APPROVE_OWN_WORK' and defaultValue IN ('Y','TRUE')) IS NOT NULL as userMayApproveOwnWork,
      (SELECT defaultValue FROM ${clientDefaultsTable} where name = 'WTR_REQUIRES_APPROVAL' and defaultValue IN ('Y','TRUE')) IS NOT NULL as requiresApproval,
      (SELECT defaultValue FROM ${clientDefaultsTable} where name = 'WTR_REQUIRES_APPROVAL2' and defaultValue IN ('Y','TRUE')) IS NOT NULL as requiresSecondApproval,
      (SELECT defaultValue FROM ${clientDefaultsTable} where name = 'WTR_REQUIRES_APPROVAL_GROUPS' and defaultValue IN ('Y','TRUE')) IS NOT NULL as requiresGroupApproval`;

      let stmt = dbService.prepareStatementQuery(permissionsQuery);
      stmt.step();
      let curPermissions = stmt.getAsObject();
      commit("RESET_USER_PERMISSIONS");
      commit("SET_MASS_PERMISSIONS", curPermissions);
      console.log("***USER WITH PERMISSIONS***", authService.getCurrentUser());

      //description: "Assign ADMIN role to a web user"​
      // feature: "SET_WEB_ADMIN_ROLE"
      // moduleID: 1325280
      // moduleName: "CASH"
      // rid: 3470058
      // syscode: "CM"

      //PERMISSIONS SETUP FROM PaymentsPanel
      // self.templateIDRequired = app.env.getBooleanDefault( Modules_and_features.kFeature_CASH_WTR_REQUIRES_TEMPLATEID)
      // self.approvalsRequired = app.env.getBooleanDefault( Modules_and_features.kFeature_CASH_WTR_REQUIRES_APPROVAL)
      // self.secondApprovalRequired = app.env.getBooleanDefault( Modules_and_features.kFeature_CASH_WTR_REQUIRES_APPROVAL2)
      // self.userMayApprove =  app.user.hasAccessToFeature(Modules_and_features.kFeature_CASH_APPROVE_EFT_LVL2)
      // self.userMayRelease = app.user.hasAccessToFeature(Modules_and_features.kFeature_CASH_APPROVE_EFT_LVL1) or app.user.hasAccessToFeature(Modules_and_features.kFeature_CASH_APPROVE_EFT_LVL2)
      // self.approverMayApproveOwnWork = app.env.getBooleanDefault(Modules_and_features.kFeature_CASH_WTR_MAY_APPROVE_OWN_WORK)

      //PERMISSIONS SETUP FROM WTRInterfaceWindow
      // self.templateIDRequired = app.env.getBooleanDefault( Modules_and_features.kFeature_CASH_WTR_REQUIRES_TEMPLATEID)
      // self.approvalsRequired = app.env.getBooleanDefault( Modules_and_features.kFeature_CASH_WTR_REQUIRES_APPROVAL)
      // self.secondApprovalRequired = app.env.getBooleanDefault( Modules_and_features.kFeature_CASH_WTR_REQUIRES_APPROVAL2)
      // self.userMayEnque = app.user.hasAccessToFeature(Modules_and_features.kFeature_CASH_ENQUE_WTR) or app.user.hasAccessToFeature(Modules_and_features.kFeature_CASH_ROUTE_TO_EFT)
      // self.approverMayApproveOwnWork = app.env.getBooleanDefault(Modules_and_features.kFeature_CASH_WTR_MAY_APPROVE_OWN_WORK)
    },
  },
};
